import {CoinsField} from "@game/ui/components/CoinsIndicator/CoinsField";
import {CoinsIndicatorProps} from "@game/ui/components/CoinsIndicator/CoinsIndicator";
import {SVG} from "@game/ui/images";
import cn from "classnames";
import "./CoinsIndicator.less";
import {UIConstants} from "@game/ui/constants";

export const PopupWinIndicator = ({className, total = 600}: CoinsIndicatorProps) => {
    return (
        <div className={"absolute_box"}>
            <div className={cn(className)}>
                <CoinsField
                    className={cn("coins-indicator__total", "coins-indicator__plus")}
                    total={total}
                    tickupDuration={total > 0 ? UIConstants.popup.updateCoinsTime : 0}
                />
                <div className={cn("coins-indicator__icon")}>{<SVG.COINS />}</div>
            </div>
        </div>
    );
};
